import React from "react";
import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import './Hows.css'
// import { Link } from "react-router-dom";


const Hows = () => {
  return (
    
   
    <>
    <div className="container-xxl py-5 hero-header1">
      <div className="container my-5 py-5 px-lg-5">
        <div className="row g-5 py-5">
          <div className="col-12 text-center">
            <h1 className="text-white animated slideInDown">How It's Work</h1>
            <hr className="bg-white mx-auto mt-0" style={{ width: "90px" }} />
          </div>
        </div>
      </div>
    </div>
    

    <div className="container my-5">
      <div className="row align-items-center">
        
        {/* First Column - Check Marks and Headings */}
        <div className="col-md-5">
          <h1 className="section-title">We work in three ways</h1>
          <ul className="check-list ">
            <li><FaCheckCircle className="check-icon" /> Google Adsense campaigning with Collab with Meta</li>
            
            <li><FaCheckCircle className="check-icon" /> Hashtags target and blog's Marketing with Collab with Meta</li>
            
            <li className="mb-5"><FaCheckCircle className="check-icon" /> Influencer Marketing Collab with Meta Ads</li>
          </ul>
          <Link
        to="/get-started#payment-section"
        className="get-started1 text-decoration-none  py-sm-3 px-sm-5 rounded-pill me-3 animated slideInLeft"
        
      >
        Get Started
      </Link>
        </div>

        {/* Second Column - Text Content */}
        <div className="col-md-7" id="howtext">
          <p>
            Basically we target the hashtags that you use on your postings. We focus and make sure that your profile will be pushed to the people of same interest.  
            Same for location. We will target your locations and make sure that your each post will be pushed to explore page of your familiar locations.
          </p>
          <p>
            This is how you will get all engagement from niche of your interest and region. Whenever interested people see, they'll engage with your account and this is how it'll grow your sales.
          </p>
          <p>
            First of all, I will make your account visible. So your each story and post will be seen by followers. Also, I will promote your each post and stories so many users will go through your account and story.
          </p>
          <p>
            We have a team and main network through all over the globe mainly UK, UAE, Dubai, US, Italy, Germany, Austria, and all over Europe. So we already have 6 Million+ active real users in our network that will engage with your account.
          </p>
          <p>
            That gets you real engagement, real followers, also high insights on each post and account statistics.
          </p>
        </div>
        
      </div>
    </div>
      
    </>
  );
};

export default Hows;




